<div class="flex flex-col md:flex-row justify-between items-start gap-4">
  <div>
    <h2 class="list-header__title">{{ title }}</h2>
    <p class="list-header__subtitle" *ngIf="subTitle">{{ subTitle }}</p>
  </div>
  <ng-content></ng-content>
</div>